import React from "react";

interface IProps extends React.HTMLAttributes<SVGElement> {
    color?: string;
}

export default function CheckboxTickIcon(props: IProps) {
    return (
        <svg {...props} viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M0.432,13.652c-0.271,0.316-0.403,0.717-0.371,1.132c0.032,0.415,0.223,0.793,0.54,1.063l7.684,6.587 c0.285,0.244,0.639,0.375,1.011,0.375c0.046,0,0.092-0.002,0.139-0.006c0.42-0.037,0.799-0.238,1.067-0.563L23.646,6.243 c0.264-0.322,0.387-0.727,0.347-1.141c-0.042-0.414-0.24-0.788-0.562-1.053l-2.406-1.976c-0.663-0.544-1.645-0.448-2.191,0.215 L9.388,13.785c-0.368,0.447-1.031,0.505-1.47,0.129l-3.264-2.796c-0.65-0.557-1.638-0.481-2.195,0.169L0.432,13.652z"
            />
        </svg>
    );
}
